// NAS Archive — plain-Japanese display strings (kept apart from DMS copy).
export const NAS_I18N = {
  disabled_title: 'この機能は現在無効です',
  disabled_hint: '「状態」タブの管理パネルから有効化してください（管理者のみ）。',
  not_configured: 'NASソースが登録されていません',
  not_configured_hint: '「状態」タブでソースを登録し、ドライ棚卸しを実行してから、1つのフォルダーをパイロットとして有効化してください。',
  test_source: 'テストソース',
  awaiting: '未設定 — 有効化待ち',
  not_indexed: '未取り込み',
  read_only_note: 'NASアーカイブは読み取り専用です。ここから編集・移動・削除・アップロードはできません。',
  scope_note: '表示されるのは、管理者が承認したフォルダー（AI学習・情報ソースの対象範囲）だけです。範囲外・システム・隠しフォルダーは表示されません。',
  scope_empty_title: '承認された対象範囲がありません',
  scope_empty_hint: '「AI学習・情報ソース」でNASの対象フォルダーを承認してください（管理者のみ）。',
  location_open: '元の場所を開く',
  location_lan_only: 'この機能はLAN接続時のみ利用できます',
  location_paste_hint: 'Win+R（またはエクスプローラーのアドレス欄）に貼り付けてEnterで開きます。',
  location_full_path: 'NASパス（全体）',
};
